import { Checkbox } from 'antd';
import cn from 'classnames';
import type { ComponentProps, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Col } from '../../col';
import type { TooltipProperties } from '../../tooltip';
import { Item, type ItemProperties } from '../item';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
type CheckboxItemProperties<FormValues = any> = {
  hidden?: boolean;
  label?: ReactNode | string;
} & Omit<ItemProperties<FormValues>, 'children' | 'label'>;

type InputProperties = {
  'aria-label'?: string;
  'data-test-id'?: string; // This is missing from antd, similar to other HTML properties
} & Omit<ComponentProps<typeof Checkbox>, 'css'>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
type P<FormValues = any> = {
  input?: InputProperties;
  item: CheckboxItemProperties<FormValues>;
  tooltip?: TooltipProperties;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
const CheckboxInput = <FormValues = any,>({ input, item }: P<FormValues>) => {
  const { t } = useTranslation();

  return (
    <Item valuePropName="checked" {...item} className={cn('checkbox-input', item.className)} label={null}>
      <Checkbox {...input}>
        {item.label ? <Col>{typeof item.label === 'string' ? t(item.label) : item.label}</Col> : null}
      </Checkbox>
    </Item>
  );
};

export default CheckboxInput;
